import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../function/config";
import axios from "axios";
import Logo from "../video/Mariniz Logo Gold.png";
import Basic from "./PlansImage/BasicPack.jpg";
import Premium from "./PlansImage/PremiumPack.jpg";
import PlatinumPack from "./PlansImage/PlatinumPack.jpg";
import { h4 } from "framer-motion/client";
import { toast } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";

export default function UserDashboard() {
  const token = localStorage.getItem("token");
  const [email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [ci, setCi] = useState("");
  const [username, setusername] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const [count, setCount] = useState(0);

  const [myShips, setMyShips] = useState([]);
  const [charter, setCharters] = useState([]);
  const [allImagesReg, setAllImagesReg] = useState([]);
  const [combinedList, setCombinedList] = useState([]);

  const [subscriptionPlan, setSubscriptionPlan] = useState("");
  const [planDays, setPlanDays] = useState(0);

  const [expiryData, setExpiryData] = useState({});

  // Function to calculate remaining days
const calculateRemainingDays = (expiresAt) => {
  if (!expiresAt) return { text: "", status: "never" };

  const now = new Date();
  const expiry = new Date(expiresAt);

  const diffTime = expiry - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return { text: "Expired", status: "expired" };
  if (diffDays === 0) return { text: "Expires today", status: "urgent" };
  if (diffDays === 1) return { text: "1 day left", status: "warning" };
  return { text: `${diffDays} days left`, status: "normal" };
};

  // Function to check and update expired ships
const checkAndUpdateExpiredShips = async (ships) => {
  const now = new Date();

  for (const ship of ships) {
    const expiryDate = ship.expires_at ? new Date(ship.expires_at) : null;

    if (expiryDate && expiryDate < now) {
      if (
        (ship.type === "Sale" && ship.is_allow) ||
        (ship.type === "Charter" && ship.is_status)
      ) {
        try {
          let url = "";
          if (ship.type === "Sale") {
            url = `${config.base_url}/api/HappyMarineShipping/deny/update/${ship.id}/`;
            await axios.patch(url, {}, {
              headers: {
                Authorization: `Token ${token}`,
              },
            });
            setMyShips((prev) =>
              prev.map((item) =>
                item.id === ship.id ? { ...item, is_allow: false } : item
              )
            );
          } else {
            url = `${config.base_url}/api/HappyMarineShipping/updateCharter/${ship.id}`;
            await axios.patch(url, { is_status: false }, {
              headers: {
                Authorization: `Token ${token}`,
              },
            });
            setCharters((prev) =>
              prev.map((item) =>
                item.id === ship.id ? { ...item, is_status: false } : item
              )
            );
          }

          setExpiryData((prev) => ({
            ...prev,
            [ship.id]: { text: "Expired", status: "expired" },
          }));

          console.log(`Expired ship updated: ${ship.id}`);
        } catch (err) {
          console.error(`Error updating ship ${ship.id}:`, err);
        }
      }
    }
  }
};


  const merged = [
    ...myShips.map((s) => ({
      ...s,
      type: "Sale",
      created_at: s.created_at ? new Date(s.created_at) : new Date(0),
      expires_at: s.expires_at,
    })),
    ...charter.map((c) => ({
      ...c,
      type: "Charter",
      created_at: c.created_at ? new Date(c.created_at) : new Date(0),
      expires_at: c.expires_at,
    })),
  ];

  // Update the combined list with expiry information
  useEffect(() => {
    if (!myShips.length && !charter.length) return;

    const merged = [
      ...myShips.map((s) => ({
        ...s,
        type: "Sale",
        created_at: s.created_at ? new Date(s.created_at) : new Date(0),
        expires_at: s.expires_at,
      })),
      ...charter.map((c) => ({
        ...c,
        type: "Charter",
        created_at: c.created_at ? new Date(c.created_at) : new Date(0),
        expires_at: c.expires_at,
      })),
    ];

    // Sort newest first
    merged.sort((a, b) => b.created_at - a.created_at);

    // Calculate remaining days for each item
    const expiryInfo = {};
    merged.forEach((item) => {
      expiryInfo[item.id] = calculateRemainingDays(item.expires_at);
    });

    setExpiryData(expiryInfo);
    setCombinedList(merged);

    // Check and update expired ships
    checkAndUpdateExpiredShips(merged);
  }, [myShips, charter, token]);

  const [userId, setUserId] = useState(null);
  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Fetch user data and ships
  useEffect(() => {
    async function fetchAll() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/alluser`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        if (res2.data.Status === 200) {
          setusername(res2.data.user.username);
          setEmail(res2.data.user.email);
          setPhone(res2.data.user.phone);
          setUserId(res2.data.user.id);
          setCi(`${config.base_url}${res2.data.user.image}`);
          const plan = res2.data.user.subscription_plan; // assuming this field exists
          setSubscriptionPlan(plan);

          let days = 0;
          if (plan === "free") days = 10;
          else if (plan === "basic") days = 30;
          else if (plan === "premium") days = 60;
          else if (plan === "platinum") days = 90;
          setPlanDays(days);
        }

        const shipRes = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
          { headers: { Authorization: `Token ${token}` } }
        );
        if (shipRes.data.status === 200) {
          const sortedData = shipRes.data.data
            .filter((ship) => ship.user === res2.data.user.id)
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          setMyShips(sortedData);
          checkAndUpdateExpiredShips(merged);
        }
      } catch (error) {
        console.log("Error fetching user data or ships:", error);
      }
    }
    fetchAll();
  }, [token, count]);

  // Fetch images
  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (res3.data.status === 200) {
          setAllImagesReg(res3.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, []);

  const [charterImg, setCharterImg] = useState([]);

  useEffect(() => {
    async function fetchCharterImages() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images_CReg`,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (res3.data.status === 200 && Array.isArray(res3.data.data)) {
          setCharterImg(res3.data.data);
        } else {
          setCharterImg([]);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchCharterImages();
  }, []);

  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
    const [userShipsCount, setUserShipsCount] = useState(0);
  const [maxLimit, setMaxLimit] = useState(1);
  const [userPlan, setUserPlan] = useState("free");
  
  const [isAdmin, setIsAdmin] = useState(false);
  
  useEffect(() => {
    async function fetchUserShips() {
      try {
        const response = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/userShipsCount`,
          { headers: { Authorization: `Token ${token}` } }
        );
  
        if (response.data.status === 200) {
          setUserShipsCount(response.data.current_count);
          setMaxLimit(response.data.max_limit);
          setUserPlan(response.data.plan);
          setIsAdmin(response.data.is_admin); // 👈 new
        }
      } catch (error) {
        console.log("Error fetching user ships count:", error);
      }
    }
    if (token) fetchUserShips();
  }, [token]);
  
useEffect(() => {
    async function fetchUserPlan() {
      if (!token) return;

      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/userShipsCount`,
          {
            headers: { Authorization: `Token ${token}` },
          }
        );
        if (res.data.status === 200) {
          setUserPlan(res.data.plan); // plan could be 'free', 'basic', 'premium', 'platinum'
        }
      } catch (err) {
        console.log("Error fetching user plan:", err);
      }
    }

    fetchUserPlan();
  }, [token]);


  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = combinedList.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(combinedList.length / itemsPerPage);

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Auto close sidebar when screen ≤ 950px
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 950) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    handleResize(); // Run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 950);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 950);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 950) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    // Run on mount
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };
  const handleDeleteReg = async (id) => {
    try {
      const response = await axios.delete(
        `${config.base_url}/api/HappyMarineShipping/deleteShipForSale/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setCount(id);
        toast.success("Ship Deleted Successfully !", {
          autoClose: 1000,
          position: "top-right",
        });
      } else {
        toast.error("Error", {
          autoClose: 2000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };

  const handleDeleteCharter = async (id) => {
    try {
      const response = await axios.delete(
        `${config.base_url}/api/HappyMarineShipping/deleteCharter/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setCount(id);
        toast.success("Ship Deleted Successfully !", {
          autoClose: 1000,
          position: "top-right",
        });
      } else {
        toast.error("Error", {
          autoClose: 2000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };

  // Initialize Stripe with your public key
const stripePromise = loadStripe("pk_test_51S0Hq4AoFmIatDnEm7xiA3Q1tcRmUtOczUSEa4XbdYmLj7JlIYYKchpMr6Ep7EquYVkMcwq6xXdjlAcSoA1xg44Q00ow8ldvSZ"); 
const [selectedPlan, setSelectedPlan] = useState(null);

const handlePlanClick = (plan) => {
  setSelectedPlan(plan);
  setShowPaymentPopup(true);
};

const handleProceedToPayment = async () => {
  try {
    const stripe = await stripePromise;

    const res = await axios.post(
      `${config.base_url}/api/HappyMarineShipping/create-checkout-session/`,
      {
        plan: selectedPlan,success_url: window.location.href, 
        cancel_url: window.location.href, // current page if cancel
      },
      {
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.url) {
      // Redirect to Stripe checkout
      window.location.href = res.data.url;
    }
  } catch (err) {
    toast.error("Failed to create checkout session", { autoClose: 2000 });
    console.error(err);
  }
};


  const handleUpgradePlan = async (plan) => {
    if (!isAdmin && userShipsCount >= maxLimit) {
      
      setShowPaymentPopup(true);
      return;
    }
  try {
    const res = await axios.post(
      `${config.base_url}/api/HappyMarineShipping/upgrade_plan`,
      { plan },
      {
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.status === 200) {
      toast.success(res.data.message, { autoClose: 2000 });

      // Update subscription plan in local state
      setSubscriptionPlan(plan);

      // Force refresh ships so new is_allow + expires_at values come in
      setCount((prev) => prev + 1);
    } else {
      toast.error(res.data.message, { autoClose: 2000 });
    }
  } catch (err) {
    toast.error("Error upgrading plan", { autoClose: 2000 });
    console.error(err);
  }
};

 useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const payment = params.get("payment");
  const sessionId = params.get("session_id");

  if (payment === "success" && sessionId) {
    axios.post(
  `${config.base_url}/api/HappyMarineShipping/verify-payment/`,
  { session_id: sessionId },
  { headers: { Authorization: `Token ${token}` } }
)
.then(res => {
  if (res.status === 200 && res.data.message === "Payment verified") {
    // Refresh plan after Stripe verification
    axios.get(`${config.base_url}/api/HappyMarineShipping/getUserPlan/`, {
      headers: { Authorization: `Token ${token}` }
    }).then(res2 => {
      if (res2.data.status === 200) {
        setUserPlan(res2.data.plan);
        setShowPaymentPopup(false);
        toast.success("Plan upgraded successfully!");
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    });
  } else {
    toast.error("Payment verification failed!");
  }
})
.catch(() => toast.error("Could not verify payment."));
  }
}, [token]);

  return (
    <div className="flex h-screen transition-all duration-300 ease-in-out">
      {/* Sidebar */}
      <div
        className={`bg-[#253356] text-white h-[100vh] overflow-hidden transition-all duration-300 ease-in-out ${
          isSidebarOpen
            ? isMobile
              ? "w-full" // full width on small screens
              : "w-60" // 60px on larger screens
            : "w-0"
        }`}
      >
        <div className="p-5">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold">Mariniz</h2>
            <button
              onClick={toggleSidebar}
              className="text-2xl focus:outline-none"
            >
              <i className="fa-solid fa-bars"></i>
            </button>
          </div>

          <div className="py-3 mt-2">
            <img className="w-[80px] h-[80px] rounded-full" src={ci} alt="" />
          </div>

          <ul className="space-y-4 mt-3">
            <li
              onClick={() => navigate("/userHome")}
              className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356] cursor-pointer"
            >
              Home
            </li>
            <li
              onClick={() => navigate("/userDashboard")}
              className="bg-[#d1a460] transition-all scale-105 duration-300 p-2 font-semibold rounded-r-full shadow-lg text-[#253356] cursor-pointer"
            >
              Dashboard
            </li>
            <li
              onClick={() => navigate("/userlist")}
              className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356] cursor-pointer"
            >
              My Listing
            </li>
            <li
              onClick={() => navigate("/userprofile")}
              className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356] cursor-pointer"
            >
              Profile
            </li>
            <li
              onClick={handleLogout}
              className="hover:bg-[#d1a460] hover:transition-all hover:scale-105 hover:duration-300 p-2 hover:rounded-r-full hover:shadow-lg hover:font-semibold hover:text-[#253356] cursor-pointer"
            >
              Logout
            </li>
          </ul>
        </div>
      </div>

      {/* Main Content */}
      <div
        className={`transition-all duration-300 ease-in-out overflow-y-auto flex-1 px-5 py-2 bg-gray-100 ${
          isSidebarOpen ? "ml-0" : "w-full"
        }`}
      >
        <div className="flex items-center justify-between mb-6">
          {!isSidebarOpen && (
            <button
              onClick={toggleSidebar}
              className="text-2xl text-gray-600 focus:outline-none"
            >
              <i className="fa-solid fa-bars"></i>
            </button>
          )}
        </div>

        <div className="bg-white p-5 flex justify-between rounded-lg text-[#253356] font-semibold shadow">
          <p className="text-3xl xm:text-xl">
            Welcome,{" "}
            <span className="text-[#d1a460] font-bold italic">{username}!</span>
          </p>
          <button
            onClick={() => navigate("/regShip")}
            className="bg-[#253356] rounded-lg p-2  text-white"
          >
            New Listing +
          </button>
        </div>
        <div className="flex gap-5  sm:flex-wrap w-[100%] mt-6 p-5">
          {/* registered list */}
          <div className="w-[55%] sm:w-[100%] text-[#253356]">
            <h3 className="text-xl font-bold mb-4">Recent Listing</h3>
            {currentItems.length > 0 ? (
              <div className="grid grid-cols-2 justify-center 2xl:grid-cols-1 sm:flex ssm:flex-wrap gap-5">
                {currentItems.map((item) => {
                  const expiryStatus = expiryData[item.id]?.status || "normal";
                  const expiryText = expiryData[item.id]?.text || "";

                  return (
                    <div
                      key={`${item.id}`}
                      className="bg-white w-[300px] ssm:w-[400px] xm:w-[100%] rounded-lg p-4 shadow relative"
                    >
                      {/* Expiry badge */}
                      <div
                        className={`absolute -top-2 -right-2 px-2 py-1 rounded text-xs font-bold ${
                          expiryStatus === "expired"
                            ? "bg-red-500 text-white"
                            : expiryStatus === "urgent"
                            ? "bg-red-600 text-white"
                            : expiryStatus === "warning"
                            ? "bg-orange-500 text-white"
                            : expiryStatus === "normal"
                            ? "bg-green-500 text-white"
                            : "bg-blue-500 text-white"
                        }`}
                      >
                        {expiryText}
                      </div>

                      <div className="flex justify-between items-center">
                        <h4 className="text-lg font-semibold mb-2">
                          {item.vessel_type}{" "}
                          <span className="text-xs ml-2 text-gray-500">
                            ({item.type})
                          </span>
                        </h4>

                        <div>
                          {item.is_allow === true || item.is_status === true ? (
                            <h4 className="text-green-600 font-semibold">
                              Approved
                            </h4>
                          ) : (
                            <h4 className="text-yellow-500 font-semibold">
                              Pending
                            </h4>
                          )}
                        </div>
                      </div>

                      <div>
                        {(() => {
                          let firstImage = Logo;
                          if (item.type === "Sale") {
                            const images = allImagesReg
                              .filter((img) => img.ships === item.id)
                              .sort((a, b) => a.id - b.id);
                            if (images.length > 0) {
                              firstImage = images[0].image;
                            }
                          } else if (item.type === "Charter") {
                            const images = charterImg
                              .filter((img) => img.charter === item.id)
                              .sort((a, b) => a.id - b.id);
                            if (images.length > 0) {
                              firstImage = images[0].image;
                            }
                          }

                          return (
                            <img
                              src={firstImage || Logo}
                              className="w-full rounded-lg cursor-pointer h-[110px]"
                              alt="Ship"
                            />
                          );
                        })()}
                      </div>

                      <div className="mt-3 float-end">
                        <button
                          onClick={() => {
                            if (item.type === "Sale") {
                              handleDeleteReg(item.id);
                            } else {
                              handleDeleteCharter(item.id);
                            }
                          }}
                          className="bg-red-500 text-white rounded-lg py-1 px-2"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-gray-600">
                You haven't registered any ships yet.
              </p>
            )}
            {totalPages > 1 && (
              <div className="flex justify-center mt-4 space-x-2 items-center">
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  className={`px-3 py-1 rounded flex items-center justify-center ${
                    currentPage === 1
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-[#d1a460] text-white"
                  }`}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>

                <div className="px-5 py-1 rounded bg-[#d1a460] text-white font-semibold select-none">
                  {currentPage}
                </div>

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className={`px-3 py-1 rounded flex items-center justify-center ${
                    currentPage === totalPages
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-[#d1a460] text-white"
                  }`}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            )}
          </div>

          {/* Premium */}
          <div className="w-[50%] sm:w-[100%] mt-6 bg-gray-800 h-full rounded-lg">
            <div className="p-5   ">
              <h1 className="text-4xl 2xl:text-3xl text-transparent bg-clip-text bg-gradient-to-r from-[#e3af62] to-[#f0c27c] text-center font-bold drop-shadow-lg tracking-wide">
                Boost Your Ship's Visibility
              </h1>
              <div className="mt-5 flex flex-wrap justify-center gap-4">
                <div onClick={() => handlePlanClick("basic")} className="w-[250px]  2xl:w-auto 2xl:h-auto border border-[#d1a460] p-2 text-center cursor-pointer transition-all hover:scale-105 duration-300 h-[250px] rounded-lg">
                  <img src={Basic} className="rounded-lg" alt="" />
                </div>
                <div onClick={() => handlePlanClick("premium")} className="w-[250px] 2xl:w-auto 2xl:h-auto border border-[#d1a460] p-2 text-center cursor-pointer transition-all hover:scale-105 duration-300 h-[250px] rounded-lg">
                  <img src={Premium} className="rounded-lg" alt="" />
                </div>
                <div onClick={() => handlePlanClick("platinum")}  className="w-[250px] 2xl:w-auto 2xl:h-auto border border-[#d1a460] p-2 text-center cursor-pointer transition-all hover:scale-105 duration-300 h-[250px] rounded-lg">
                  <img src={PlatinumPack} className="rounded-lg" alt="" />
                </div>
                {/* <div className="w-[250px] 2xl:w-auto 2xl:h-auto border border-[#d1a460] p-2 text-center cursor-pointer transition-all hover:scale-105 duration-300 h-[250px] rounded-lg">
                  <img src={Basic} className="rounded-lg" alt="" />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPaymentPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white w-[30%] p-6 rounded-xl shadow-lg max-w-sm ">
      <h2 className="text-2xl font-bold text-[#253356] mb-4 text-center">
        Confirm {selectedPlan?.toUpperCase()} Plan
      </h2>

      {/* Show plan image */}
      <div className="flex justify-center mb-4">
        <img
          src={
            selectedPlan === "basic"
              ? Basic
              : selectedPlan === "premium"
              ? Premium
              : PlatinumPack
          }
          alt={selectedPlan}
          className="w-[200px] h-[200px] object-cover rounded-lg shadow"
        />
      </div>

      <p className="mb-4 text-gray-600 text-center">
        You are about to upgrade to the{" "}
        <span className="font-semibold capitalize">{selectedPlan}</span> plan.
      </p>

      <div className="flex justify-center gap-3">
        <button
          onClick={() => setShowPaymentPopup(false)}
          className="px-4 py-2 bg-gray-300 rounded-lg"
        >
          Cancel
        </button>
        <button
          // onClick={handleProceedToPayment}
          className="px-4 py-2 bg-[#d1a460] text-white rounded-lg"
        >
          Proceed to Payment
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
}
